module.exports = __webpack_public_path__ + "static/media/browse_left.e8d20ff0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/browse_left.svg
// module id = 591
// module chunks = 0